/**
 * Enum para as chaves de abas (selectedTab)
 */
export const TabKeyEnum = Object.freeze({
  APROVADOS:     'aprovados',
  REVISAO:       'revisao',
  PRE_APROVADOS: 'pre-aprovados',
  OFERTAS:       'ofertas',
  APROVAR:       'aprovar',
  DRAFT:         'draft',
  APROVADOS_IA:  'aprovados-ia'
});

/**
 * Enum para os valores de stateToProduct (o que vem da API)
 */
export const ProductStateEnum = Object.freeze({
  APPROVED:     'APPROVED',
  REVISION:     'REVISION',
  PRE_APPROVED: 'PRE_APPROVED',
  OFFERS:       'OFFERS',
  REQUESTED:    'REQUESTED',
  DRAFT:        'DRAFT',
  IA_APPROVED:  'IA_APPROVED',
  DRAFT_OBSERVATION: 'DRAFT_OBSERVATION',
});

/**
 * Mapeamento direto de TabKeyEnum para ProductStateEnum
 */
export const TabToStateMap = Object.freeze({
  [TabKeyEnum.DRAFT]:         [ProductStateEnum.DRAFT, ProductStateEnum.DRAFT_OBSERVATION],
  [TabKeyEnum.APROVAR]:       ProductStateEnum.REQUESTED,
  [TabKeyEnum.PRE_APROVADOS]: ProductStateEnum.PRE_APPROVED,
  [TabKeyEnum.REVISAO]:       ProductStateEnum.REVISION,
  [TabKeyEnum.APROVADOS]:     ProductStateEnum.APPROVED,
  [TabKeyEnum.APROVADOS_IA]:  ProductStateEnum.IA_APPROVED,
  [TabKeyEnum.OFERTAS]:       ProductStateEnum.OFFERS,
});
